import type {
  MetricComparison,
  PerformancePageOverview,
} from 'api/new-analytics/types';
import type { FbReactionId } from '../components/fbReactionsConstants';
import NumberUtil from 'utils/number';

export const FB_REACTION_TO_METRIC_KEY: Record<FbReactionId, string> = {
  angry: 'reactions_angry',
  like: 'reactions_like',
  love: 'reactions_love',
  haha: 'reactions_haha',
  sad: 'reactions_sad',
  wow: 'reactions_wow',
};

export interface FbReactionEntry {
  value: number;
  previousValue?: number;
  changePercent?: number;
}

export type FbReactionsByType = Record<FbReactionId, FbReactionEntry>;

export function getFacebookReactionsFromOverview(
  overview: PerformancePageOverview | undefined,
): FbReactionsByType {
  const result = {} as FbReactionsByType;
  (Object.keys(FB_REACTION_TO_METRIC_KEY) as FbReactionId[]).forEach((id) => {
    const metricKey = FB_REACTION_TO_METRIC_KEY[id];
    const metric = overview?.[metricKey] as MetricComparison | undefined;
    const value = NumberUtil.coalesceFinite(metric?.value) ?? 0;
    const entry: FbReactionEntry = { value };
    const pv = NumberUtil.coalesceFinite(metric?.previous_value);
    if (pv !== undefined) {
      entry.previousValue = pv;
    }
    const cp = NumberUtil.coalesceFinite(metric?.change_percent);
    if (cp !== undefined) {
      entry.changePercent = cp;
    }
    result[id] = entry;
  });
  return result;
}
